import React, {Component} from "react";
import * as actions from "./actions/action";
import {FlightType} from "./actions/action";
import {AnyAction, bindActionCreators, Dispatch} from "redux";
import {connect} from "react-redux";
import {log, mapData} from "./Tools";
import {Map, TileLayer} from 'react-leaflet'
import {LocationsType, StateBaseType} from "./store";
import LPolylines from "./LPolylines";
import LHeatmap from "./LHeatmap";
import {isPasswordReset, isReturnFromPayment, loginImageStatus} from "./PureTools";

interface LocalStateType {
    center: [number, number]
}

interface InputType {
    /* from parent */
    mapZoom: number,
    setParentForceLineRender: any,
}

interface StateType {
    flights: FlightType[],
    locations: LocationsType,
    isFilter: boolean,
    windowHeight: number,
    centerMap: boolean,
    mapType: number,
    mapReference: any
    /* from redux props mapping*/
}

interface DispatchType {
    /* from redux actions*/
    setMapReferenceLeaflet: typeof actions.setMapReferenceLeaflet,
    unveil: typeof actions.unveil,
    setMapZoomLeaflet: typeof actions.setMapZoomLeaflet
}

type PropsType = InputType & StateType & DispatchType;

class LMap extends Component<PropsType, LocalStateType> {

    constructor(props: PropsType) {
        super(props);

        this._setUpdateFlightsAndLocationsFunction = this._setUpdateFlightsAndLocationsFunction.bind(this);
        this._unveil = this._unveil.bind(this);
        this._getMeasurements = this._getMeasurements.bind(this);
        this._setMapZoom = this._setMapZoom.bind(this);
        //this._center = this._center.bind(this);

        this.state = {
            center: [60.3171 * 0.8, 24.9633]
        };
        this._unveil();
    }

    _unveil() {
        log('_unveil', loginImageStatus);
        if (!(loginImageStatus.loaded || loginImageStatus.unveiled || isReturnFromPayment ||isPasswordReset)) {
            setTimeout(this._unveil, 500);
        } else if (!loginImageStatus.unveiled) {
            const bootDiv = document.getElementById("overbody");

            // already unveiled, switching between map sources
            if (!bootDiv) {
                return;
            }

            this.props.unveil();
            bootDiv.classList.add('done');
            loginImageStatus.unveiled = true;
            setTimeout(() => {
                bootDiv.addEventListener('webkitAnimationEnd', removeIt);
                bootDiv.addEventListener('animationEnd', removeIt);

                function removeIt() {
                    log('unveiled');
                    if (bootDiv) {
                        bootDiv.remove();
                    }
                }
            }, 2000);
        }
    }

    _getMeasurements() {
        // @ts-ignore
        return (document.getElementById('overbody') || document.getElementById('appDiv')).getBoundingClientRect();
    }

    // @ts-ignore
    updateFlightsAndLocationsToChild = (flights, locations, filter) => {
    };
    _setUpdateFlightsAndLocationsFunction(func: any) {
        this.updateFlightsAndLocationsToChild = func;
    }


    componentDidMount() {
        // TODO is this needed for something?
        //this._leafletMap.leafletElement.on('zoomend', (e: any) => {
        //});
    }

    _setMapZoom() {
        this.props.setMapZoomLeaflet(this.props.mapReference.leafletElement.getZoom());
    }

    render() {
        log('render lmap', this.props.mapZoom, this.state, this.props.windowHeight, window.innerHeight, this._getMeasurements()?.height);

        const height = window.innerHeight; //this.props.windowHeight ? this.props.windowHeight : this._getMeasurements().height;
        const mapEntry = mapData()[this.props.mapType];

        return (
            <Map
                ref={(component: any) => {
                    this.props.setMapReferenceLeaflet(component);
                }}
                center={this.state.center}
                minZoom={2}
                maxZoom={8}
                zoom={this.props.mapZoom}
                onzoomend={this._setMapZoom}
                worldCopyJump={true}
                // tapTolerance={20}
                style={{width: '100%', height: height + 'px'}}
            >
                <TileLayer
                    attribution={mapEntry.attribution}
                    url={mapEntry.url}
                />

                <LHeatmap
                    setUpdateFlightsAndLocationsFunction={this._setUpdateFlightsAndLocationsFunction}
                    mapZoom={this.props.mapZoom}
                    setParentForceLineRender={this.props.setParentForceLineRender}
                />

                <LPolylines
                    setUpdateFlightsAndLocationsFunction={this._setUpdateFlightsAndLocationsFunction}
                    mapZoom={this.props.mapZoom}
                    setParentForceLineRender={this.props.setParentForceLineRender}
                />

            </Map>
        )
    }

}

const mapStateToProps = (state: StateBaseType) => {
    return {
        flights: state.reducer.flights,
        locations: state.reducer.locations,
        isFilter: state.reducer.isFilter,
        windowHeight: state.reducer.windowHeight,
        centerMap: state.reducer.centerMap,
        mapType: state.reducer.mapType,
        mapReference: state.reducer.mapReferenceLeaflet
    }
};

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => {
    return bindActionCreators<any, any>(actions, dispatch);
};

export default connect<StateType, DispatchType, InputType, StateBaseType>(mapStateToProps, mapDispatchToProps)(LMap);
